import { useState } from "react";
import { Col, Menu, Row } from "antd";
import UserDetailPage from "./detail/user_detail_page";
import UserTransaction from "./detail/user_transaction";
import UserBank from "./detail/bank/user_bank";
import { useSelector } from "react-redux";
import GameLogs from "./detail/game_logs";

export default function UserDetail({ closeDrawer, detail }) {
  const [activeTab, setActiveTab] = useState("detail");
  const {permissions} = useSelector((state) => state.user)

  const tabComponents = {
    detail: <UserDetailPage detail={detail} closeDrawer={closeDrawer} />,
    transaction: permissions.includes("AGENT_READ_USER_TRANSACTION") && <UserTransaction detail={detail} closeDrawer={closeDrawer} />, 
    bank: permissions.includes("AGENT_READ_USER_BANK_ACCOUNT") && <UserBank detail={detail} closeDrawer={closeDrawer} />,
    logs : permissions.includes("AGENT_READ_USER_GAME_LOGS") && <GameLogs detail = {detail} closeDrawer={closeDrawer}/>
  };

  const menuItems = [
    { label: "Detail", key: "detail" },
    { label: "Transactions", key: "transaction", permissions : ["AGENT_READ_USER_TRANSACTION"] },
    { label: "Bank", key: "bank", permissions : ["AGENT_READ_USER_BANK_ACCOUNT"] },
    { label : "Game Logs", key : "logs", permissions : ["AGENT_READ_USER_GAME_LOGS"]}
  ];


  const filteredMenuItems = menuItems.filter((item) => {
    if (!item.permissions) return true
    return item.permissions.every(perm => permissions.includes(perm));
  });
  return (
    <Row>
      <Col span={24}>
        <Menu
          onClick={(e) => setActiveTab(e.key)}
          selectedKeys={[activeTab]}
          mode="horizontal"
          items={filteredMenuItems}
        />
      </Col>
      <Col span={24} style={{ padding: "20px", overflowX: "hidden" }}>
        {tabComponents[activeTab]}
      </Col>
    </Row>
  );
}
